/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Load_ErrorInputs */

const en_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an issue loading share codes. Please close and reopen this window.`)
};

const fr_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu lors du chargement des codes de partage. Veuillez fermer et rouvrir cette fenêtre.`)
};

const de_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Laden der Freigabecodes ist ein Problem aufgetreten. Bitte schließen Sie dieses Fenster und öffnen Sie es erneut.`)
};

const it_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un problema durante il caricamento dei codici di condivisione. Chiudi e riapri questa finestra.`)
};

const ru_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возникла проблема при загрузке кодов доступа. Пожалуйста, закройте и откройте это окно снова.`)
};

const es_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un problema al cargar los códigos para compartir. Cierre y vuelva a abrir esta ventana.`)
};

const zh_cn2_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享码加载失败。请关闭并重新打开此窗口。`)
};

const ja_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シェアコードの読み込み中に問題が発生しました。このウィンドウを閉じて再度開いてください。`)
};

const hi_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर कोड लोड करने में समस्या आ रही है। कृपया इस विंडो को बंद करके दोबारा खोलें।`)
};

const pt_pt2_team_share_load_error = /** @type {(inputs: Team_Share_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um problema ao carregar os códigos de compartilhamento. Feche e abra esta janela novamente.`)
};

/**
* | output |
* | --- |
* | "There was an issue loading share codes. Please close and reopen this window." |
*
* @param {Team_Share_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_load_error = /** @type {((inputs?: Team_Share_Load_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Load_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_load_error(inputs)
	if (locale === "de") return de_team_share_load_error(inputs)
	if (locale === "it") return it_team_share_load_error(inputs)
	if (locale === "ru") return ru_team_share_load_error(inputs)
	if (locale === "es") return es_team_share_load_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_load_error(inputs)
	if (locale === "ja") return ja_team_share_load_error(inputs)
	if (locale === "hi") return hi_team_share_load_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_load_error(inputs)
	return en_team_share_load_error(inputs)
});